document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector('.hu-erinnerung');
    if (container.querySelector('.info-inner')) {
        container.scrollIntoView({behavior: 'smooth'});
    }

    const kennzeichen = document.querySelector('.kennzeichen');
    if (!kennzeichen) return;

    kennzeichen.addEventListener('keydown', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLElement)) return;

        let pattern = ''
        if (input.id === 'hu_reminder_kennz') {
            pattern = /[a-zäüö]/i;
        } else if (input.id === 'hu_reminder_kennz2') {
            pattern = /[a-z]/i;
        } else if (input.id === 'hu_reminder_kennz3') {
            pattern = /[\dehc]/i;
        }
        if (!pattern.test(event.key) && event.key !== 'Tab') event.preventDefault()
    })

    kennzeichen.addEventListener('input', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLElement)) return;

        if (input.nodeName === 'INPUT') {
            input.value = input.value.toUpperCase();
        }
    })

    container.querySelector('#hu_reminder_email_second').addEventListener('paste', (e) => e.preventDefault());
});